// extracted by mini-css-extract-plugin
export var active = "_fp-7";
export var blink = "_fp-8";
export var dropDownSelector = "_fp-4";
export var dropDownWrapper = "_fp-3";
export var fakeCursor = "_fp-6";
export var fontSizeButton = "_fp-9";
export var formQuillEditor = "_fp-0";
export var pressed = "_fp-a";
export var qlBlank = "_fp-1";
export var textFormattingToolbar = "_fp-2";
export var textToolbarOption = "_fp-5";